module.exports = __webpack_public_path__ + "static/media/drum-steelpan.d9b27e13.svg";